import { currentUser, pb } from "$lib/pocketbase";
import { initClientI18n } from "$lib/i18n";

const initializeClientI18n = async () => {
  try {
    await initClientI18n();
  } catch (error) {
    console.error("Failed to initialize i18n:", error);
  }
};

if (typeof window !== "undefined") {
  if (document.readyState !== "loading") {
    initializeClientI18n();
  } else {
    window.addEventListener("DOMContentLoaded", initializeClientI18n);
  }
}

pb.authStore.loadFromCookie(document.cookie);
pb.authStore.onChange(() => {
  const model = pb.authStore.model;
  if (model && typeof model.id === "string" && model.id !== "") {
    currentUser.set(model);
  } else {
    currentUser.set(null);
  }
  document.cookie = pb.authStore.exportToCookie({ httpOnly: false });
}, true);

export function handleError({ error, event }) {
  console.error("Ein Fehler ist aufgetreten:", error);
  return {
    message: "Ein unerwarteter Fehler ist aufgetreten."
  };
}
